<template>
  <BaseCard noPadding class="tw:mt-4">
    <InvoicesContainer />
  </BaseCard>
</template>
<script setup lang="ts">
import BaseCard from '@/components/dashboard/BaseCard.vue'
import InvoicesContainer from '@/components/billing/invoices/InvoicesContainer.vue'
</script>
